import * as React from "react";
import { useSelector } from "react-redux";
import { getPortfoliosOptions } from "~/Redux/portfolios";
import { WithEditModeViewerProps, withEditMode } from "~/sharedHOC/withEditMode/withEditMode";
import { withValidation } from "~/sharedHOC/withValidation/withValidation";
import { InlineSelectDefaultProps } from "../inlineEdit/Controls";
import { InlineEditSelectViewer } from "../inlineEdit/InlineEditSelectViewer";
import { withInlineEdit } from "../inlineEdit/withInlineEdit";
import { getItemId } from "../list";
import { PortfolioList } from "./PortfolioList";

export const PortfolioInlineEditSelect = withInlineEdit(
    withValidation(withEditMode(PortfolioList)),
    InlineSelectDefaultProps
);

export const PortfolioInlineEditViewer: React.FC<WithEditModeViewerProps & { initialText: string }> = props => {
    const options = useSelector(getPortfoliosOptions);
    return <InlineEditSelectViewer valueSelector={getItemId} {...props} options={options} />;
};
